export default "__VITE_ASSET__BY4DKV5x__"